<template>
  <q-dialog v-model="shown">
    <q-card style="width: 500px;">
      <q-card-section class="row items-center q-mx-xs q-gutter-xs full-width no-wrap">
        <div class="text-h6 col ellipsis">
          All Filters
        </div>
        <q-space />
        <q-btn
          class="col-auto"
          dense
          outline
          label="Reset All"
          size="sm"
          @click="reportElement.resetAllFilters()"
        />
        <q-btn
          v-close-popup
          class="col-auto"
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-input
          v-model.trim="optionsSearchString"
          debounce="200"
          style="margin-bottom: 15px"
          placeholder="Search filters.."
          clearable
          dense
        />
        <div
          class="justify-between q-mt-sm"
        >
          <transition-group
            name="list-complete"
          >
            <div
              v-for="column in matchingOptions"
              :key="column.field"
              style="margin-bottom: -1px"
              class="list-complete-item"
            >
              <q-item
                style="border: solid 1px #CCC;"
                :class="reportElement.isFieldFiltered(column.field) ? '' : 'bg-grey-3'"
                clickable
                @click="$emit('edit-filter', column.field)"
              >
                <q-item-section>
                  {{ column.label || column.name || $_.startCase(column.field) }}
                </q-item-section>
                <q-item-section
                  class="col-auto"
                  style="border: solid 1px #ddd;"
                >
                  <q-checkbox
                    :model-value="reportElement.isFieldFiltered(column.field)"
                    label="Filtered"
                    class="q-mr-md q-ml-xs"
                    @update:model-value="$emit('edit-filter', column.field)"
                    @click.prevent
                  />
                </q-item-section>
              </q-item>
            </div>
          </transition-group>
        </div>
        <div
          v-if="optionsSearchString && matchingOptions.length == 0"
          class="q-pa-lg text-center"
        >
          No Matching Searches
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'ReportFiltersDialog',
  components: {
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Values'
    },
    modelValue: {
      type: Boolean,
      required: false
    },
    reportElement: {
      type: Object,
      required: true
    }
  },
  emits: ['edit-filter', 'update:model-value'],
  data () {
    return {
      shown: false,
      optionsSearchString: null
    }
  },
  computed: {
    filterableColumns () {
      // Show columns that have been filtered to first
      return _.sortBy(this.reportElement.filterableColumns, column => this.reportElement.isFieldFiltered(column.field) ? 0 : 1)
    },
    matchingOptions () {
      if (!this.optionsSearchString) return this.filterableColumns

      const searchString = this.optionsSearchString.toLowerCase()
      return _.filter(
        this.filterableColumns,
        option => {
          const label = option.label || option.name || _.startCase(option.field)
          return (_.includes(label.toLowerCase(), searchString))
        }
      )
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    }
  }
}

</script>

<style lang="scss" scoped>
.list-complete-item {
  transition: all 0.5s;
}
.list-complete-enter {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
